import styled, { css } from 'styled-components';

export const StyledFilterContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s4};
  `}
`;
